import AccDropdown from "./AccDropdown"
import CartDropdown from "./CartDropdown"
import ProductsDropdown from "./ProductsDropdown"
import HamburgerMenu from "./HamburgerMenu/HamburgerMenu"
import { useState, useContext, useMemo } from "react"
import cartContext from "../../context/cartContext"
import "./Nav.css"

const NavRight = () => {
  const [menuShowing, setMenuShowing] = useState(false)

  const { cart } = useContext(cartContext)

  /* ===============================
     TOTAL CART COUNT (BADGE VALUE)
  =============================== */
  const cartCount = useMemo(() => {
    return (cart || []).reduce((total, item) => {
      return total + (item.qty || 1)
    }, 0)
  }, [cart])

  return (
    <>
      <ul className="navbar-nav mb-0 align-items-center navFull">
        <ProductsDropdown />
        <AccDropdown />

        {/* PASS BADGE COUNT HERE */}
        <CartDropdown cartCount={cartCount} />
      </ul>

      <div className="navSmall navbar-nav align-items-center">
        <button
          type="button"
          className="hamburger-toggle"
          aria-label={menuShowing ? "Close menu" : "Open menu"}
          aria-expanded={menuShowing}
          aria-controls="mobile-menu"
          onClick={() => setMenuShowing(!menuShowing)}
        >
          <svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true">
            <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        </button>
      </div>

      <HamburgerMenu
        menuShowing={menuShowing}
        setMenuShowing={setMenuShowing}
      />
    </>
  )
}

export default NavRight
